"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
// helper method for creating ReportEventUnauthenticated parameters
exports.createReportEventUnauthenticatedParams = function (eventType, serviceName, properties) { return ({
    event: { m_eventType: eventType, m_serviceName: serviceName, m_properties: properties }
}); };
//# sourceMappingURL=ReportEventUnauthenticatedParams.js.map